export function isHttpError(
  err: unknown,
): err is { response: { status: number; data: unknown } } {
  return (
    typeof err === 'object' &&
    err !== null &&
    'response' in err &&
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeof (err as any).response === 'object' &&
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (err as any).response !== null &&
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeof (err as any).response.status === 'number' &&
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'data' in (err as any).response
  )
}
